'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enhance = exports.FileInput = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _Layout = require('./Layout');

var _Layout2 = _interopRequireDefault(_Layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FileInput = function FileInput(_ref) {
  var multiple = _ref.multiple,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      value = _ref.value,
      button = _ref.button,
      text = _ref.text,
      layout = _ref.layout,
      rest = _objectWithoutProperties(_ref, ['multiple', 'onChange', 'onClick', 'value', 'button', 'text', 'layout']);

  var input = _react2.default.createElement('input', _extends({
    type: 'file',
    onChange: onChange,
    multiple: multiple,
    hidden: true,
    files: value,
    value: ''
  }, rest));

  var buttonEl = (0, _react.cloneElement)(button, {
    multiple: multiple,
    value: value,
    onClick: onClick
  });

  var textEl = (0, _react.cloneElement)(text, {
    multiple: multiple,
    value: value
  });

  var layoutEl = (0, _react.cloneElement)(layout, {
    input: input,
    button: buttonEl,
    text: textEl,
    multiple: multiple,
    value: value
  });

  return layoutEl;
};

exports.FileInput = FileInput;
var enhance = exports.enhance = (0, _recompose.compose)((0, _recompose.setDisplayName)('FileInput'), (0, _recompose.setPropTypes)({
  // Input pass throughs
  id: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.array,
  multiple: _propTypes2.default.bool,
  // Renderers
  button: _propTypes2.default.element,
  text: _propTypes2.default.element,
  layout: _propTypes2.default.element,

  // Events
  onChange: _propTypes2.default.func
}), (0, _recompose.defaultProps)({
  multiple: false,
  text: (0, _react.createElement)(_Text2.default),
  layout: (0, _react.createElement)(_Layout2.default)
}), (0, _recompose.withHandlers)({
  onClick: function onClick(_ref2) {
    var id = _ref2.id;
    return function () {
      document.getElementById(id).click();
    };
  }
}));

exports.default = enhance(FileInput);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/react-file-input/lib/FileInput.js
// module id = 918
// module chunks = 0